// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import lisIssueResolutionEntity from './entities/lis-issue-resolution.json';
import lisIssueResolutionMenu from '../pages/lis-issue-resolution/menu.json';
import lisIssueResolutionFullForm from '../pages/lis-issue-resolution/forms/full.json';
import lisIssueResolutionContextForm from '../pages/lis-issue-resolution/forms/context.json';
import lisIssueResolutionMiniForm from '../pages/lis-issue-resolution/forms/mini.json';
import lisIssueResolutionLookupForm from '../pages/lis-issue-resolution/forms/lookup.json';
import lisIssueResolutionTableView from '../pages/lis-issue-resolution/views/table.json';
import lisIssueResolutionCardsView from '../pages/lis-issue-resolution/views/cards.json';
import lisIssueResolutionDashboardView from '../pages/lis-issue-resolution/views/dashboard.json';

/** Тип запису «Вирішення проблеми» зі сторінками пакета: меню, форми та подання з pages/lis-issue-resolution/. */
export const lisIssueResolutionDefinition: IRecordTypeDefinition = {
  ...lisIssueResolutionEntity,
  views: assembleViewSet({
      table: lisIssueResolutionTableView,
      cards: lisIssueResolutionCardsView,
      dashboard: lisIssueResolutionDashboardView,
  }),
  form: lisIssueResolutionFullForm,
  forms: { full: lisIssueResolutionFullForm, context: lisIssueResolutionContextForm, mini: lisIssueResolutionMiniForm, lookup: lisIssueResolutionLookupForm },
  menu: lisIssueResolutionMenu,
} as IRecordTypeDefinition;
